import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

export default function initBenefits () {
  const $blocks = document.querySelectorAll('.wp-block-benefits')
  $blocks.forEach($block => {
    // eslint-disable-next-line no-new
    new Benefits($block)
  })
}

/**
 *
 * @param {HTMLElement} $el HTML Element
 */
class Benefits {
  constructor (element) {
    this.$el = element
    this.$slider = this.$el.querySelector('.benefits-slider')
    this.$pagination = this.$el.querySelector('.pagination')
    this.init()
  }

  init () {
    if (this.$slider) {
      this.swiper = new Swiper(this.$slider, {
        modules: [Pagination],
        slidesPerView: 'auto',
        loop: false,
        allowTouchMove: true,
        spaceBetween: 30,
        grabCursor: true,
        pagination: {
          el: this.$pagination
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          }
        }
      })
    }
  }
}
